<template>
  <ValidationProvider :name="name" :rules="rules" v-slot="{ errors }" mode="passive">
      <b-form-select
        :id="id"
        v-model="inputVal"
        :state="state(errors)"
        :options="options"
        :value-field="valueField"
        :text-field="valueTextField"
        :disabled-field="disabledField"
        :required="required"
        :disabled="disabled"
      ></b-form-select>
      <b-form-invalid-feedback :state="state(errors)">
        {{ errors[0] }}
      </b-form-invalid-feedback>
  </ValidationProvider>
</template>

<script>
import { BFormSelect, BFormInvalidFeedback } from 'bootstrap-vue';
import agcFormElementMixin from '../../mixins/agc-form-element';

export default {
  components: {
    BFormSelect,
    BFormInvalidFeedback,
  },
  mixins: [agcFormElementMixin],
  props: {
    options: Array,
    valueField: { type: String, default: 'value' },
    valueTextField: { type: String, default: 'text' },
    disabledField: { type: String, default: 'disabled' },
  },
};
</script>
